const ERROR = 'Error';

let initialState = {
    message: null
}

export default function( state = initialState, action){
    switch(action.type){
        case ERROR:
            return {
                message: action.payload
            }
        default:
            return state;
    }
}